module.exports = __webpack_public_path__ + "plat/static/img/wait.27d5beb4.svg";